
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brand]/order",
      function () {
        return require("private-next-pages/[brand]/order.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brand]/order"])
      });
    }
  